module.exports = __webpack_public_path__ + "static/media/bannerimage.61fd3295.png";